export default "__VITE_ASSET__zr2aJ46U__"